import {Model} from "@/store/models/model";
import {Country} from "@/store/models/country";
import axios from "@/store/vue-axios/axios";


export class DomainTld extends Model {

  static entity = 'domain_tlds'
  static primaryKey = 'tld'

  static fields() {
    return {
      id: this.attr(null),
      tld: this.string(''),
      country_code: this.string(''),

      created_at: this.attr(null),
      updated_at: this.attr(null),

      country: this.belongsTo(Country, 'country_code')
    }
  }

  static async fetchPopular() {
    const result = await axios.get('domain/domains/tlds/popular')

    this.insert({data: result.data.tlds})

    return result.data.tlds
  }

}

export default DomainTld



// WEBPACK FOOTER //
// ./src/store/models/domain/domain_tld.js